/* eslint-disable no-useless-escape */
export default {
    OK: { code: 0, message: "ok" },
    UNUSUAL: { code: 100, message: "unusual" },
    MISSING: { code: 200, message: "missing" },
    WARNING: { code: 300, message: "warning" },
    WARNING_CUSTOM: { code: 301, message: "custom" },
    WARNING_MISSING: { code: 302, message: "missing" },
    WARNING_NON_NUMERIC: { code: 303, message: "non-numeric" },
    WARNING_TOO_SHORT: { code: 304, message: "\'%s\' shorter than minimum length [%s]" },
    WARNING_TOO_LONG: { code: 305, message: "\'%s\' longer than maximum length [%s]" },
    WARNING_LENGTH: { code: 306, message: "invalid length" },
    WARNING_PRECISION: { code: 307, message: "\'%s\' exceeds allowed digits [%s]" },
    WARNING_SCALE: { code: 308, message: "\'%s\' exceeds allowed fractional digits [%s]" },
    WARNING_OUT_OF_RANGE: { code: 310, message: "out of range" },
    WARNING_LESS_THAN_MIN: { code: 311, message: "%s less than allowed minimum [%s]" },
    WARNING_GREATER_THAN_MAX: { code: 312, message: "%s greater than allowed maximum [%s]" },
    WARNING_OUT_OF_USUAL_RANGE: { code: 320, message: "out of usual range" },
    WARNING_LESS_THAN_USUAL_MIN: { code: 321, message: "%s less than usual minimum [%s]" },
    WARNING_GREATER_THAN_USUAL_MAX: { code: 322, message: "%s greater than usual maximum [%s]" },
    WARNING_ATOMIC_OPTIONS: { code: 330, message: "%s must be selected atomically" },
    WARNING_INACTIVE_OPTION: { code: 331, message: "%s is not active" },
    ILLEGAL: { code: 400, message: "illegal" },
    ILLEGAL_CUSTOM: { code: 401, message: "custom" },
    ILLEGAL_MISSING: { code: 402, message: "missing" },
    ILLEGAL_NON_NUMERIC: { code: 403, message: "non-numeric" },
    ILLEGAL_TOO_SHORT: { code: 404, message: "\'%s\' shorter than minimum length [%s]" },
    ILLEGAL_TOO_LONG: { code: 405, message: "\'%s\' longer than maximum length [%s]" },
    ILLEGAL_LENGTH: { code: 406, message: "invalid length" },
    ILLEGAL_PRECISION: { code: 407, message: "\'%s\' exceeds allowed digits [%s]" },
    ILLEGAL_SCALE: { code: 408, message: "\'%s\' exceeds allowed fractional digits [%s]" },
    ILLEGAL_OUT_OF_RANGE: { code: 410, message: "out of range" },
    ILLEGAL_LESS_THAN_MIN: { code: 411, message: "%s less than allowed minimum [%s]" },
    ILLEGAL_GREATER_THAN_MAX: { code: 412, message: "%s greater than allowed maximum [%s]" },
    ILLEGAL_OUT_OF_USUAL_RANGE: { code: 420, message: "out of usual range" },
    ILLEGAL_LESS_THAN_USUAL_MIN: { code: 421, message: "%s less than usual minimum [%s]" },
    ILLEGAL_GREATER_THAN_USUAL_MAX: { code: 422, message: "%s greater than usual maximum [%s]" },
    ILLEGAL_ATOMIC_OPTIONS: { code: 430, message: "%s must be selected atomically" },
    ILLEGAL_INACTIVE_OPTION: { code: 431, message: "%s is not active" },
    BLOCKING: { code: 500, message: "record cannot be saved until error is resolved" },
};



// WEBPACK FOOTER //
// ./app/jsmodel/error.js